import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'age'
})
export class AgePipe implements PipeTransform {
  transform(value: any, type?: string): any {
    if (value === 0 || value === null) {
      return null;
    } else {
      if (type === 'until') {
        return '〜' + value + '歳';
      } else {
        return value;
      }
    }
  }
}
